<script lang="ts">

import { login } from "../api";

let username: string = "";
let password: string = "";

let status: "" | "loading" | "success" | "error" = "";
let error: string = "";

async function formSubmit (e: Event) {
	e.preventDefault();

	status = "loading";

	try {
		await login(username, password);
		status = "success";

	} catch (e) {
		error  = e;
		status = "error";
	}
}

</script>

{#if status === "error"}
	<div class="alert alert-danger">
		<p class="mb-0">
			<strong>Error: </strong> {error}
		</p>
	</div>
{/if}
<form action="" on:submit={formSubmit}>
	<div class="row mb-3">
		<label for="login-username" class="col-sm-2 col-form-label">Username</label>
		<div class="col-sm-10">
			<input type="text" bind:value="{username}" class="form-control" id="login-username">
		</div>
	</div>
	<div class="row mb-3">
		<label for="login-username" class="col-sm-2 col-form-label">Password</label>
		<div class="col-sm-10">
			<input type="password" bind:value="{password}" class="form-control" id="login-username">
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-sm-10 offset-sm-2">
			<button type="submit" class="btn btn-primary">Log in</button>
		</div>
	</div>
</form>
